import type {
  StateEditFieldOptionItem,
  StateEditFieldValue,
} from "./state-edit-field.type";
import type { ReferentialModelState } from "@/entities/referential/referential-states";

export const getStateEditFieldOption = (
  value: StateEditFieldValue,
  states?: ReferentialModelState[]
): StateEditFieldOptionItem | undefined => {
  const state = states?.find((s) => s.value === value);

  if (!state) return undefined;

  const { name, color } = state;

  return { label: name, value, color: color };
};

export const getStateEditFieldOptions = (
  values?: StateEditFieldValue[],
  states?: ReferentialModelState[]
): StateEditFieldOptionItem[] => {
  return (values ?? [])
    .map((value) => getStateEditFieldOption(value, states))
    .filter((option) => !!option);
};
